import { FileSignature, Link2, ListChecks, MessageCircle, Radio, Sparkles } from 'lucide-vue-next';
import type { LucideIcon } from 'lucide-vue-next';
import { TenantType } from '@/config/constants/enums';

export type HeroValueProp = {
    key: string;
    comingSoon?: boolean;
};

export const HERO_VALUE_PROPS: Record<TenantType, HeroValueProp[]> = {
    [TenantType.SUPPLIER]: [
        { key: 'home.hero.supplier.value_props.contract_signing' },
        { key: 'home.hero.supplier.value_props.rates_specials' },
        { key: 'home.hero.supplier.value_props.chat_ticketing' },
        { key: 'home.hero.supplier.value_props.media_sharing' },
        { key: 'home.hero.supplier.value_props.live_availability', comingSoon: true },
        { key: 'home.hero.supplier.value_props.agent_discovery', comingSoon: true },
    ],
    [TenantType.AGENT]: [
        { key: 'home.hero.agent.value_props.contract_signing' },
        { key: 'home.hero.agent.value_props.receive_rates_specials' },
        { key: 'home.hero.agent.value_props.rate_exports' },
        { key: 'home.hero.agent.value_props.itinerary_builder' },
        { key: 'home.hero.agent.value_props.supplier_discovery', comingSoon: true },
        { key: 'home.hero.agent.value_props.live_availability', comingSoon: true },
    ],
};

export const FEATURE_IDS = ['contracts', 'connection_lists', 'availability', 'specials', 'network', 'messaging'] as const;

export type FeatureId = (typeof FEATURE_IDS)[number];

export const COMING_SOON_FEATURES: ReadonlySet<FeatureId> = new Set(['availability']);

/**
 * The homepage features that can be pitched today, in the homepage's own order.
 * Coming-soon features are excluded on purpose: nothing outside the homepage
 * grid (which badges them) may sell a capability that is not live yet.
 *
 * Used by the canonical claim page so a supplier landing from a cold email is
 * sold on exactly the feature set, in exactly the order, the homepage uses.
 */
export const SELLABLE_FEATURE_IDS: readonly FeatureId[] = FEATURE_IDS.filter((id) => !COMING_SOON_FEATURES.has(id));

/** The icon each feature is recognised by, shared by every surface that lists them. */
export const FEATURE_ICONS: Record<FeatureId, LucideIcon> = {
    contracts: FileSignature,
    connection_lists: ListChecks,
    availability: Radio,
    specials: Sparkles,
    network: Link2,
    messaging: MessageCircle,
};

export const TOURI_CAPABILITY_IDS = ['smart_search', 'rate_lookup', 'proposal_assistance', 'product_knowledge'] as const;
